import { useEffect, useMemo, useRef } from "react"

import { QuillStatic } from "../../types"

import { EffectProps, EffectValueForGet } from "./types"
import { EFFECT_BLOT_NAME, EFFECT_MODULE_NAME } from "./constants"
import { registerEffectModule } from "./module"

export const registerEffect = (Quill: QuillStatic) => {
  registerEffectModule(Quill)
}

export const useEffectModules = (modules: {
  [key: string]: any
} = {}, props: EffectProps = {}) => {
  const isActivatedEffect = !!props.effect

  const onClickGestureRef = useRef<(
    el: HTMLElement, 
    value: EffectValueForGet,
  ) => void>()
  const getEffectClipListRef = useRef<() => string[]>()
  const getEffectBlotListRef = useRef<() => {
    id: string
    effectClipId: string
    effectId: string
    effectName: string
    order: number
    connected: boolean
  }[][]>()

  useEffect(() => {
    if (!!props.effect && typeof props.effect === 'object') {
      onClickGestureRef.current = props.effect?.onClick
      getEffectClipListRef.current = props.effect?.getEffectClipList
      getEffectBlotListRef.current = props.effect?.getEffectBlotList
    }
    else {
      onClickGestureRef.current = undefined
      getEffectClipListRef.current = undefined
      getEffectBlotListRef.current = undefined
    }
  }, [props.effect])

  const memoizedModules = useMemo(() => {
    const mergedModules = {
      ...modules,
    }

    if (isActivatedEffect) {
      mergedModules[EFFECT_MODULE_NAME] = {
        onClick: (
          el: HTMLElement, 
          value: EffectValueForGet,
        ) => onClickGestureRef.current?.(el, value),

        getEffectClipList: () => getEffectClipListRef.current?.(),

        getEffectBlotList: () => getEffectBlotListRef.current?.(),
      }
    }

    return mergedModules
  }, [modules, isActivatedEffect])

  return memoizedModules
}

export const useEffectFormats = (
  formats: string[] = [], 
  props: EffectProps = {},
) => {
  const isActivatedEffect = !!props.effect
  
  const memoizedFormats = useMemo(() => {
    const mergedFormats = [
      ...formats,
    ]

    if (isActivatedEffect) {
      mergedFormats.push(EFFECT_BLOT_NAME)
    }

    return mergedFormats
  }, [formats, isActivatedEffect])

  return memoizedFormats
}
